<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Leave Workflows</p>
      </div>

      <div class="border-b-0.5 flex justify-between items-center pl-0 ml-0 p-2">
        <div class="flex justify-between items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>
        <div class="flex flex-wrap justify-end w-full gap-3">
          <button
            @click="showCreateCreateWorkflow = true"
            class="bg-primary flex gap-1 text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            <p>Create</p>
          </button>
        </div>
      </div>

      <div class="px-2 pt- pb-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ del_error }}
          </div>

          <div
            v-if="del_success"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showEditSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showDeptDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_dept }}
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>

        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No workflows found
          </p>

          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>

        <company-setup-review-workflow-user-group
          :show-review-workflow-user-group="showReviewWorkflowUserGroup"
          @close="showReviewWorkflowUserGroup = false"
          :workflowToReview="workflowToReview"
          :getWorkflow="getWorkflow"
        ></company-setup-review-workflow-user-group>

        <company-setup-create-leave-workflow
          :show-create-leave-workflow="showCreateCreateWorkflow"
          @close="showCreateCreateWorkflow = false"
          :getWorkflow="getWorkflow"
        ></company-setup-create-leave-workflow>

        <company-setup-edit-leave-workflow
          :showEditWorkflow="showEditWorkflow"
          @close="showEditWorkflow = false"
          :getWorkflow="getWorkflow"
          :info="workflowToEdit"
        ></company-setup-edit-leave-workflow>

        <action-warning
          :message="message"
          :set-is-confirmed="setIsConfirmed"
          :show-warning="showWarning"
          @close="showWarning = false"
          :title="title"
        ></action-warning>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Loader from "@/components/loader/loader.vue";
import CompanySetupReviewWorkflowUserGroup from "./reviewWorkflowUserGroup.vue";
import CompanySetupCreateLeaveWorkflow from "./create.vue";
import CompanySetupEditLeaveWorkflow from "./editLeaveworkflow.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
// import Switches from 'vue-switches';
export default {
  name: "leaveWorkflow",
  components: {
    Loader,
    CompanySetupReviewWorkflowUserGroup,
    CompanySetupCreateLeaveWorkflow,
    ActionWarning,
    CompanySetupEditLeaveWorkflow,
  },
  data() {
    return {
      showEditError: false,
      showEditWorkflow: false,
      loading: false,
      selectedOption: "",
      isCheckboxDisabled: false,
      showReviewWorkflowUserGroup: false,
      showCreateCreateWorkflow: false,
      workflowToReview: null,
      isBlank: false,
      get_error: null,
      create_success: "Department created successfully",
      del_dept: "Department deleted successfully",
      del_error: null,
      del_success: null,
      showEditSuccess: false,
      showDeptDelSuccess: false,
      searchInput: "",
      workflowToDelete: null,
      workflowToEdit: null,
      title: "",
      message: "",
      workflow: "",
      showWarning: false,
      info: {
        Sequence1: "",
        Sequence2: "",
        Sequence3: "",
      },
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          title: "Name",
          field: "Name",
          key: "name",

          align: "left",
          renderBodyCell: ({ row }) => {
            return (
              <div on-click={() => this.viewWorkflow(row)}>
                <p class="text-blue-500 cursor-pointer">{row.Name}</p>
              </div>
            );
          },
        },
        {
          title: "Location",
          field: "Location",
          key: "location",
          headerAlign: "left",
          align: "left",
        },

        {
          title: "Branch",
          field: "Branch",
          key: "Branch",
          headerAlign: "left",
          align: "left",
        },
        {
          title: "Any Can Approve",
          field: "AnyCanApprove",
          key: "AnyCanApprove",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.AnyCanApprove}></VeCheckbox>
          ),
        },

        {
          title: "Department",
          field: "Department",
          key: "department",
          headerAlign: "left",
          align: "left",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>

                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getWorkflow(), this.getEmployees(), this.setPageSizes();
  },

  methods: {
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }

      // Add the increment value to each page size in the array
      // for (let i = 0; i < this.pageSizes.length; i++) {
      //   this.pageSizes[i] += pageSizeIncrement;
      // }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },

    viewWorkflow(workflow) {
      this.showReviewWorkflowUserGroup = true;
      this.workflowToReview = workflow;
      this.$store.commit("setWorkflowToReview", workflow);
    },

    handleDeleteButtonClick(workflow) {
      this.title = `Delete ${workflow.Name}`;
      this.message = `You are about to delete ${workflow.Name}!`;
      this.workflowToDelete = workflow;
      this.showWarning = true;
    },

    handleEditButtonClick(workflow) {
      this.showEditWorkflow = true;
      this.workflowToEdit = workflow;
    },

    getUpdatedWorkflow(index) {
      const workflow = this.tableData.Members[index];
      this.workflowToEdit = workflow;
      console.log(workflow, index);
    },

    setIsConfirmed() {
      this.showWarning = false;
      this.deleteWorkflow(this.workflowToDelete);
    },

    getWorkflow(index = null) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leave/workflow/group/${this.$ApiVersion}/request`,

          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.tableData = response.data.Data;
              if (index) {
                this.getUpdatedWorkflow(index);
              }
              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;

            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },
    // /{organization}/setup/leave/workflow/group/{leaveworflowId}/v1/delete
    deleteWorkflow(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/leave/workflow/group/${row.Id}/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 400) {
              this.del_success = response.data.StatusMessage;
              this.getWorkflow();
              setTimeout(() => {
                this.del_success = null;
              }, 2500);
            } else {
              this.del_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 2500);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 2500);
          }
        );
    },

    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$store.commit("setEmployees", response.data.Data);
              this.employees = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
